import React from 'react';
import { strengths } from '../data/strengths';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function Strengths() {
  return <section aria-labelledby="strengths-title" className="bg-ink py-20 md:py-28" data-id="element-354" data-mp="263924ghathek">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-355" data-mp="2157i9tc1te21">
        <SectionHeading id="strengths-title" tone="dark" label="07 · Professional strengths" title="The qualities behind the career." data-id="element-356" data-mp="214o1ify4wvpl" />
        <ul className="mt-16 grid gap-x-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-357" data-mp="1s49gziszvkn5">
          {strengths.map((s, i) => <li key={s.title} className="border-t border-line-dark" data-id="element-358" data-mp="1n4n1f2pp1sb6" data-mpi={i}>
              <Reveal delay={Math.min(i, 5) * 0.04} className="py-8" data-id="element-359" data-mp="1n6zplxm1oywo">
                <h3 className="font-serif text-2xl text-paper" data-id="element-360" data-mp="1i7mwww8hsxm6">{s.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-slate-light" data-id="element-361" data-mp="3hi4s2yleb5af">{s.evidence}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}